<template>
	<div class="home-content-section" :data-hidden="hidden">
		<div v-if="contentSection && contentSection?.content" class="home-content-section__text rich-text">
			<template v-for="(node, index) in parsedContent" :key="index">
				<GlobalImage v-if="node.type === 'image'" :src="node.src || ''" :alt="node.alt || ''" quality="80" sizes="640px sm:1240px" />
				<div v-else v-html="node.content"></div>
			</template>
			<div class="home-content-section__gradient"></div>
			<ButtonPrimary class="home-content-section__show-btn" @click="show">{{ $t('components.seo_section.read_more') }}</ButtonPrimary>
			<ButtonPrimary class="home-content-section__hide-btn" @click="hide">{{ $t('components.seo_section.read_less') }}</ButtonPrimary>
		</div>
	</div>
</template>

<script setup lang="ts">
import { EPageSectionType } from '@/modules/adminModule/constants/pagesCMSconstants'

const { getLocaleLang } = usei18nService()
const hidden = ref(true)

function hide() {
	hidden.value = true
}
function show() {
	hidden.value = false
}

const pageSections = inject<Ref<ICMSLocationContent[]>>('pageSections')!

const contentSection = computed(() => {
	return pageSections?.value
		?.find((section: any) => section.name === EPageSectionType.CONTENT_SECTION)
		?.translations.find((t: { language: string; content: any }) => t.language === getLocaleLang())?.content[0]
})

const parsedContent = computed(() => {
	if (!contentSection.value?.content || typeof contentSection.value.content !== 'string') return []

	const content = contentSection.value.content as string
	const nodes: Array<{ type: string; content?: string; src?: string; alt?: string }> = []

	const imgRegex = /<img[^>]+src="([^"]+)"[^>]*alt="([^"]*)"[^>]*>/g
	let match
	let lastIndex = 0

	while ((match = imgRegex.exec(content)) !== null) {
		if (match.index > lastIndex) {
			nodes.push({
				type: 'text',
				content: content.slice(lastIndex, match.index),
			})
		}

		nodes.push({
			type: 'image',
			src: match[1],
			alt: match[2],
		})

		lastIndex = match.index + match[0].length
	}

	if (lastIndex < content.length) {
		nodes.push({
			type: 'text',
			content: content.slice(lastIndex),
		})
	}

	return nodes
})
</script>

<style lang="scss" scoped src="./HomePageContentSection.scss"></style>
